import React from 'react';
import { RenderAditionalInfo } from '../AditionalInfo';
import { Align, FontSize } from '../../../modules/ReceiptLayouts/Model';
import { isBoolean } from 'util';
export const BlockAditionalInfo = ({ aditionalInfo, align, fontSize, bold }) => {
    return (React.createElement(RenderAditionalInfo, { aditionalInfo: aditionalInfo, align: align || defaultProps.align, fontSize: fontSize || defaultProps.fontSize, bold: isBoolean(bold) ? bold : defaultProps.bold }));
};
const defaultProps = {
    align: Align.Center,
    fontSize: FontSize.small,
    bold: false
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockAditionalInfo.tsx
// module id = 524
// module chunks = 0